import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import { Box, IconButton } from '@mui/material';
import { useNavigate } from 'react-router';

import devTools from '@paragon/dev-tools';
import { UserDropdown } from '@paragon/themes';

import servicesLogoUrl from '../../resources/ParagonLogo.png';

interface Props {
  readonly children: React.ReactNode;
}

/**
 * This is a way to show a standard Services header on Services pages. Not every page needs this, because some use
 * login-tools forms that already have the Paragon logo and are never contexts where the user is logged in (like the log
 * in or sign up pages).
 */
export function ServicesPage(props: Props) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: 431,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', margin: 4 }}>
        <Box
          component="img"
          sx={{
            width: { xs: 250, md: 350 },
            margin: { xs: 'auto', md: 0 },
            marginRight: { md: 'auto' },
          }}
          alt="Paragon"
          src={servicesLogoUrl}
          onClick={() => void navigate('/')}
        />
        <Box sx={{ display: { xs: 'none', md: 'inline' }, marginLeft: 'auto' }}>
          <IconButton onClick={() => void navigate('/')}>
            <HomeIcon />
          </IconButton>
          <UserDropdown hideThemeToggleButton servicesPagesOpenInSameTab />
          {devTools.renderDevToolsButton()}
        </Box>
      </Box>
      <Box sx={{ overflow: 'auto' }}>{props.children}</Box>
    </Box>
  );
}
